import React, { PureComponent } from 'react';

import Placeholder from './placeholders/document.placeholder';

export default class OfficeDoc extends PureComponent {
    state = {
        loaded: false
    };

    resizeListener = () => {
        this.resizeElement();
    }

    resizeElement() {
        if (!this.element) {
            return;
        }

        this.element.style.height = `${this.element.parentElement.clientHeight}px`;
    }

    handleLoad = () => {
        setTimeout(() => {
            this.setState({
                loaded: true
            });
        }, 300);
    }

    setRef = element => this.element = element;

    componentDidMount() {
        this.resizeElement();

        window.addEventListener('resize', this.resizeListener);
    }

    componentDidUpdate() {
        this.resizeElement();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resizeListener)
    }

    render() {
        const { src, externalId } = this.props;
        let iframeSrc;

        if (externalId) {
            iframeSrc = `https://onedrive.live.com/embed?cid=${externalId}&resid=${externalId}&em=2`;
        } else {
            iframeSrc = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURI(src)}`;
        }

        return (
            <React.Fragment>
                {
                    !this.state.loaded ? <Placeholder /> : null
                }

                <iframe
                    ref={this.setRef}
                    className={'office-doc' + (!this.state.loaded ? ' loading' : '')}
                    title="Office Doc"
                    width="100%"
                    height="100%"
                    name="office-doc-disable-x-frame-options"
                    src={iframeSrc}
                    onLoad={this.handleLoad}
                />
            </React.Fragment>
        );
    }
}
